import Button, { NavigableButton } from '@carvana/ds-button';
import { type IconProps } from '@carvana/ds-icons';
import { icon } from '@carvana/ds-styles';
import Clickable from '@carvana/merch-components/Clickable';
import { ChevronRight } from 'lucide-react';
import React from 'react';
import { useIsDesktop } from '~/context/common/DeviceContext';
import { DesktopCard, TabletCard } from './Card.styles';

type OwnProps = {
  action: string | ((ev: React.MouseEvent<HTMLElement>) => void);
  desktop: {
    cta: string;
    heading: string;
    subHeading: string;
  };
  href?: string;
  nativeIncluded?: boolean;
  tablet: {
    icon: (_: IconProps) => React.ReactElement;
    text: string;
  };
  testId?: string;
};

function TabletCardContents(props: OwnProps) {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-lg">
      <props.tablet.icon color={icon.inverse} size={48} />
      <p>{props.tablet.text}</p>
      <ChevronRight color={icon.inverse} size={24} />
    </div>
  );
}

export default function Card(props: OwnProps) {
  const isDesktop = useIsDesktop();
  const { action } = props;
  const href = typeof action === 'string' ? action : props.href;
  const handleClick = typeof action === 'function' ? action : undefined;

  return isDesktop ? (
    <DesktopCard>
      <h2 className="t-heading-lg">{props.desktop.heading}</h2>
      <div className="row-span-2">
        {href ? (
          <NavigableButton
            variant="primaryInverted"
            size="sm"
            href={href}
            data-analytics-id="Hero CTA"
            data-native-included={props.nativeIncluded}
            data-testid={props.testId}
            data-analytics-attributes={{ text: props.desktop.cta }}
            onClick={handleClick}
          >
            {props.desktop.cta}
          </NavigableButton>
        ) : (
          <Button
            variant="primaryInverted"
            size="sm"
            onClick={handleClick}
            data-analytics-id="Hero CTA"
            data-testid={props.testId}
            data-analytics-attributes={{ text: props.desktop.cta }}
          >
            {props.desktop.cta}
          </Button>
        )}
      </div>
      <p className="t-body-sm">{props.desktop.subHeading}</p>
    </DesktopCard>
  ) : (
    <TabletCard>
      {href ? (
        <a
          href={href}
          className="block"
          data-analytics-id="Hero CTA"
          data-native-included={props.nativeIncluded}
          data-testid={props.testId}
          data-analytics-attributes={{ text: props.tablet.text }}
          onClick={handleClick}
        >
          <TabletCardContents {...props} />
        </a>
      ) : (
        <Clickable
          onClick={handleClick}
          data-analytics-id="Hero CTA"
          data-testid={props.testId}
          data-analytics-attributes={{ text: props.tablet.text }}
        >
          <TabletCardContents {...props} />
        </Clickable>
      )}
    </TabletCard>
  );
}
